export default __webpack_public_path__ + "static/media/classic-reward.33e0568b.svg";